// NOTE: Code fully converted from app.form.js
import { isEmpty, refreshInlineValidation } from "./global";

export function initForms() {
    if ($('.submit-element').length > 0) {
        //automatically set up override button based form submission, if tagged element present 
        //each as there could be multiple forms on the page
        $('.submit-element').each(function () {
            const formObj = $(this.form);
            formSubmissionSetUpByObj($(this), formObj);
        });
    }
}

export function onloadValidationSetupBySelector(form_selector) {
    const formObject = $(form_selector);
    return onloadValidationSetupByObject(formObject);
}

export function onloadValidationSetupByObject(form_object) {
    //ML: 12/06/2019. So, DW and I looked for a way of fixing validation issues for injected forms, and I found 
    //this solution on SO. then I discovered that we already had a version of this method; this one seems more comprehensive, so 
    //we'll use this one instead.

    //source: https://stackoverflow.com/questions/4406291/jquery-validate-unobtrusive-not-working-with-dynamic-injected-elements

    //intent is that this function is run when a form is injected dynamically into a page (i.e. not on initial load)
    form_object.removeData("validator");
    form_object.removeData("unobtrusiveValidation");
    $.validator.unobtrusive.parse(form_object);

    // This line is important and added for client side validation to trigger, without this it didn't fire client side errors.        
    const validator = form_object.validate({
        focusInvalid: false//,
        //ignore: ""
    });

    //setting this in the constructor doesn't seem to work (from memory)
    form_object.data("validator").settings.ignore = "";

    return validator;
}

export function addRequiredRule(object, preValidate) {
    object.rules("add", {
        required: true
    });

    if (preValidate === true) {
        object.valid();
    }
}

export function addRequiredRuleWithMessage(object, requiredMsg, preValidate) {
    //adds a required rule to the specific jquery object (e.g. $('# etc')).
    object.rules("add", {
        required: true,
        messages: {
            required: requiredMsg
        }
    });

    if (preValidate === true) {
        object.valid();
    }
}

export function removeRequiredRule(object) {
    //removes the required rule from a specific jquery object (e.g. $('# etc')).
    object.rules("remove", "required");
}


export function clearValidation(elementSelector) {

    var elementId = elementSelector.replace('#', '');

    var element = $(elementSelector);
    var validationSpan = $("[data-valmsg-for='" + elementId + "']");

    element.removeClass('input-validation-error');

    validationSpan.removeClass('field-validation-error');
    validationSpan.addClass('field-validation-valid');

    validationSpan.empty();

}

export function formSubmissionSetUpById(buttonId, formId, callback) {
    if (typeof formId === 'undefined') { formId = '#StandardForm'; }

    const formObject = $(formId);

    formSubmissionSetUpByObj($(buttonId), formObject, callback);
}

export function formSubmissionSetUpByObj(buttonObject, formObject, callback) {
    //onloadValidationSetupByObject(formObject);

    const validator = onloadValidationSetupByObject(formObject);

    //material element validation message setup for focus / blur
    const originalHighlight = validator.settings.highlight;
    const originalUnHighlight = validator.settings.unhighlight;

    validator.settings.highlight = function (element, errorClass, validClass) {
        refreshInlineValidation();
        originalHighlight.call(validator, element, errorClass, validClass);
    };

    validator.settings.unhighlight = function (element, errorClass, validClass) {
        refreshInlineValidation();
        originalUnHighlight.call(validator, element, errorClass, validClass);
    };

    buttonObject.off('click').on('click', function () {

        if ($('#SubmitAction').length > 0) {
            $('#SubmitAction').val($(this).attr('id'));
        }

        submitForm(validator, formObject, callback);
    });

    //search when enter key is pressed
    formObject.find('.enter-submits').off("keypress").on('keypress', function (e) {
        if (e.which === 13) {
            e.preventDefault();

            submitForm(validator, formObject, callback);
        }
    });
}

export function submitForm(validator, formObject, callback) {
    if (formObject.valid()) {
        
        if (!isEmpty(callback) && callback() === false) {
            return;
        }

        const activityIndicator = formObject.find('.submit-activity');

        //this elements are located within the submit button element 
        const buttonTextWrapper = formObject.find('.submit-button-text-wrapper');
        const buttonActivityIndicator = formObject.find('.submit-button-activity');

        if (activityIndicator.length > 0) {

            if (activityIndicator.hasClass('use-block')) {
                activityIndicator.show();
            }
            else {
                activityIndicator.show().css("display", "inline-block");
            }
        }

        if (buttonActivityIndicator.length > 0) {

            if (buttonActivityIndicator.hasClass('use-block')) {
                activityIndicator.show();
            }
            else {
                buttonTextWrapper.hide();
                buttonActivityIndicator.show().css("display", "inline-block");
            }
        }

        const popupActivityIndicator = formObject.find('.submit-activity-popup');

        if (popupActivityIndicator.length > 0) {

            if (popupActivityIndicator.hasClass('use-block')) {
                popupActivityIndicator.show();
            }
            else {
                popupActivityIndicator.show().css("display", "inline-block");
            }
        }

        formUnderSubmission(true);

        setTimeout(function () { formObject.submit(); }, 1000);
    } else {

        scrollToFirstError(validator, $(document).height() * 0.5);
        refreshInlineValidation();
    }
}

export function submitAjaxForm(button, validator, formObject, callback, activityIndicator, scrollToOnError) {
    if (formObject.valid()) {

        if (activityIndicator.length > 0) {
            activityIndicator.show().css("display", "inline-block");
        }

        button.prop("disabled", true);
        setTimeout(function () { callback(); }, 1000);
    } else {
        if (scrollToOnError) {
            scrollToFirstError(validator, $(document).height() * 0.5);
        }
    }
}

export function formUnderSubmission(status, enabledDisabledFields) {
    //disables / enables key elements on the page depending upon whether a form is being submitted (or has completed).
    if (status) {
        $('div.main-content button').prop("disabled", true);
        $('div.main-content a').addClass('disabled');

        $('modal button').prop("disabled", true);
        $('modal a').addClass('disabled');

        if (enabledDisabledFields) {

            //sometimes we want forms to submit the values held by disabled form fields. any disabled fields value will not be passed during the form post
            //the solution? get all disabled fields and add the class'marked-disabled'. then find all fields with this class and enable them just before the form is 
            //serialized and submitted. reverse the process once form submission is complete.

            $('input:disabled').addClass('marked-disabled');
            $('select:disabled').addClass('marked-disabled');

            //remove disable property from all form elements that are currently disabled
            $('input.marked-disabled').prop('disabled', false);
            $('select.marked-disabled').prop('disabled', false);
        }

    }
    else {
        $('div.main-content button').prop("disabled", false);
        $('div.main-content a').removeClass('disabled');

        $('modal button').prop("disabled", false);
        $('modal a').removeClass('disabled');

        if (enabledDisabledFields) {

            //reverse the process implemented in the if part of this function.
            $('input:disabled').removeClass('marked-disabled');
            $('select:disabled').removeClass('marked-disabled');

            $('input.marked-disabled').prop('disabled', true);
            $('select.marked-disabled').prop('disabled', true);
        }
    }
}

export function scrollToFirstError(validator, speed) {
    const firstError = $(validator.invalidElements()[0]);
    let setHeight = 0;

    if (firstError === null || firstError === undefined || firstError.length === null || firstError.length === 0) {
        setHeight = 0;
    }
    else {
        if (firstError.offset().top > ($(window).height() / 2)) {
            setHeight = firstError.offset().top - ($(window).height() / 2);
        }
    }

    $("html, body").animate({ scrollTop: setHeight }, speed);
}

export function scrollToElement(element, speed, setElementAtTop = false, setElementAtTopBuffer = 0) {
    let setHeight = 0;

    if (!setElementAtTop) {
        if (element.offset().top > ($(window).height() / 2)) {
            setHeight = element.offset().top - ($(window).height() / 2);
        }
    }
    else {

        //setElementAtTop scrolls to the location of the element on the page without trying to centre it in the view. 
        //this scrolls the page so that the element is hard against the top of the window.

        //setElementAtTopBuffer provides a buffer in pixels when setElementAtTop is used; this 'pushes down' the element by the number of pixels specified.
        //this is useful as setting the element hard to the top does no take into account sticky headers and such.

        setHeight = element.offset().top - setElementAtTopBuffer;
    }

    $("html, body").animate({ scrollTop: setHeight }, speed);
}

export function scrollToElementAlignWithTop(element, speed, offsetfromtop) {
    let setHeight = 0;

    if (element.offset().top > ($(window).height() / 2)) {
        setHeight = element.offset().top - offsetfromtop;
    }

    $("html, body").animate({ scrollTop: setHeight }, speed);
}

export function scrollToTop(speed) {
    $("html, body").animate({ scrollTop: 0 }, speed);
}


export default {
    formUnderSubmission,
    onloadValidationSetupByObject,
    addRequiredRule,
    addRequiredRuleWithMessage,
    removeRequiredRule,
    clearValidation,
    scrollToTop,
    scrollToElement,
    scrollToFirstError
};
